import React from 'react';

const ButtonBackInformativo = ({ callFunction, buttonName, callClick, css, etiqueta, icons }) => {
  return (
    <button
      name={buttonName}
      className={css ? `${css} ButtonBase` : 'ButtonBase'}
      type="button"
      onSubmit={callFunction}
      onClick={callClick}
    >
      {' '}
      {icons && <img src={icons} className="iconButtonBase" alt="svg" width="15px" height="15px" />}
      {etiqueta}
      {' '}
    </button>
  );
};

export default ButtonBackInformativo;
